import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'faq',
      component: () => import('./views/faq.vue')
    },
    {
      path: '/faq/:item',
      name: 'item',
      component: () => import('./views/item.vue')
    },
    {
      path: '/faq/:item/:answer/:position',
      name: 'answer',
      component: () => import('./views/answer.vue')
    }
  ]
})
